import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from 'libs/axios/axios';

const deleteSafetyRule = async (idList: number[]) => {
  const { data } = await axiosClient.post('/safety-rule/delete', {
    id_list: idList,
  });

  return data;
};

const useDeleteSafetyRuleQuery = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteSafetyRule, {
    onSuccess: () => {
      queryClient.invalidateQueries(['safetyRule', 'list']);
    },
    onError: (error) => {
      alert('삭제 실패. 다시 한 번 시도해주세요');
      console.error('delete safetyRule error', error);
    },
  });
};

export default useDeleteSafetyRuleQuery;
